module.exports = __webpack_public_path__ + "assets/img/errbg.1f392705.jpg";